document.addEventListener('DOMContentLoaded', function() {
  // Open all facet filter details by default
  document.querySelectorAll('#FacetsWrapperDesktop details').forEach(function(el) {
    el.setAttribute('open', true);
  });

  // User guide filter tab clicks
  document.querySelectorAll('.gn-user-guide-inner ul li a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        this.classList.add('active');
      }

      var selectedFilter = this.getAttribute('data-filter');
      var facetInput = null;

      switch (selectedFilter) {
        case 'solution-stress':
          facetInput = document.querySelector('#Facet-1-template--17449810100423__product-grid input[value="Stress"]');
          break;
        case 'solution-sleep':
          facetInput = document.querySelector('#Facet-1-template--17449810100423__product-grid input[value="Sleep"]');
          break;
        case 'solution-muscle-joint':
          facetInput = document.querySelector('#Facet-1-template--17449810100423__product-grid input[value="Muscle & Joint"]');
          break;
        case 'solution-entourage':
          facetInput = document.querySelector('#Facet-1-template--17449810100423__product-grid input[value="Entourage"]');
          break;
        case 'form-gummies':
          facetInput = document.querySelector('#Facet-2-template--17449810100423__product-grid input[value="Gummies"]');
          break;
        case 'form-oils':
          facetInput = document.querySelector('#Facet-2-template--17449810100423__product-grid input[value="Oils"]');
          break;
        case 'form-topicals':
          facetInput = document.querySelector('#Facet-2-template--17449810100423__product-grid input[value="Topicals"]');
          break;
        case 'form-soft-gels':
          facetInput = document.querySelector('#Facet-2-template--17449810100423__product-grid input[value="Soft Gels"]');
          break;
        case 'strength-light':
          facetInput = document.querySelector('#Facet-3-template--17449810100423__product-grid input[value="Light"]');
          break;
        case 'strength-medium':
          facetInput = document.querySelector('#Facet-3-template--17449810100423__product-grid input[value="Medium"]');
          break;
        case 'strength-heavy':
          facetInput = document.querySelector('#Facet-3-template--17449810100423__product-grid input[value="Heavy"]');
          break;
      }

      if (facetInput) facetInput.click();

      // Smooth scroll to product grid
      var productGrid = document.querySelector('ul#product-grid');
      if (productGrid) {
        productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});